import { render, staticRenderFns } from "./ConsumerAddress.vue?vue&type=template&id=06346a3e&"
import script from "./ConsumerAddress.vue?vue&type=script&lang=js&"
export * from "./ConsumerAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06346a3e')) {
      api.createRecord('06346a3e', component.options)
    } else {
      api.reload('06346a3e', component.options)
    }
    module.hot.accept("./ConsumerAddress.vue?vue&type=template&id=06346a3e&", function () {
      api.rerender('06346a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/consumer-orders/ConsumerAddress.vue"
export default component.exports